export const VIEW = {
  login: 0,
  register: 1,
  reset: 2,
  terms: 3
};